import { render, staticRenderFns } from "./layouts.lms.e17b3fce.vue?vue&type=template&id=99ee6272&"
import script from "./layouts.lms.e17b3fce.vue?vue&type=script&lang=js&"
export * from "./layouts.lms.e17b3fce.vue?vue&type=script&lang=js&"
import style0 from "./layouts.lms.e17b3fce.vue?vue&type=style&index=0&id=99ee6272&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LmsSnack: require('/opt/buildhome/repo/modules/lms/components/LmsSnack.vue').default})
